module.exports = __webpack_public_path__ + "media/prompt.376d1cf1.mp3";